var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.MODAL_ID,
        size: "xl",
        "hide-footer": "",
        centered: "",
        "modal-class": "translation-settings-modal",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "div",
                { staticClass: "translation-settings-modal__header w-100" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "translation-settings-modal__back",
                      attrs: { type: "button", "aria-label": "Back" },
                      on: { click: close },
                    },
                    [_c("i", { staticClass: "bi bi-arrow-left-short" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "translation-settings-modal__title" },
                    [_vm._v("\n        Translation Settings\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "translation-settings-modal__close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: close },
                    },
                    [_vm._v("\n        ×\n      ")]
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [_vm._v(" "), _c("TranslationSettingsView", { attrs: { mode: "modal" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }